enum PartitionTypes {
  Hr,
  Fm,
  Ch,
  Fc,
  Hrpm,
}

export default PartitionTypes;
